<template lang="html">

  <section class="area" v-if="inspectionArea" v-bind:class="{ 'show-errors' : showErrors }">
    <h1>{{ title }}</h1>
    <h2 v-if="alreadySubmitted">You have already submitted this room.</h2>
    <div class="user-note"v-if="!alreadySubmitted">
        <p>Please carefully examine each of the following items and mark their condition. Be sure to include a photo of any existing damage.</p>
    </div>
    <div class="area__items" v-if="!alreadySubmitted">
      <div class="area__item" v-for="areaItem in inspectionArea.InspectionAreaItems" :key="areaItem.InspectionAreaItemID">
        <div class="area__item-title">{{ areaItem.Name }}</div>
        <div class="form-item area__item-condition">
          <select v-model="areaItem.Status" :disabled="hideForm" v-bind:class="{ incomplete : areaItem.Status == '' }">
            <option value=''>Choose condition</option>
            <option v-for="areaStatus in areaItem.InspectionAreaItemStatuses" :key="areaStatus.InspectionAreaItemStatusID" :value="areaStatus.Name">{{ areaStatus.Name }} </option>
          </select>
        </div>
        <div class="form-item area__item-note"><textarea v-model="areaItem.Note" placeholder="NOTES"></textarea></div>
        <div class="form-item area__item-photo">
          <picture-input
            :ref="'pictureInput-' + areaItem.InspectionAreaItemID"
            @change="onPhotoChanged(areaItem.InspectionAreaItemID)"
            @remove="onPhotoRemoved(areaItem.InspectionAreaItemID)"
            :width="300"
            :removable="true"
            size="5"
            removeButtonClass="ui red button"
            :height="150"
            accept="image/jpeg, image/png, image/gif"
            buttonClass="ui button primary"
            :customStrings="{
            upload: 'Upload photos here',
            drag: 'Drag and drop your image here'}">

          </picture-input>
          <div class="area__item-photo-status">{{ photoUploadStatus(areaItem.InspectionAreaItemID) }}</div>
          <button @click="attemptPhotoUpload(areaItem.InspectionAreaItemID)" v-bind:class="{ disabled: ! photos.hasOwnProperty(areaItem.InspectionAreaItemID) }">Upload</button>
        </div>
      </div>
    </div>
    <div class="submit-area"  v-if="!alreadySubmitted">
      <button type="button" v-on:click="saveArea" v-if="!alreadySubmitted">Submit this Room</button>
    </div>
  </section>

</template>

<script lang="js">

  import router from '@/router.js';
import PictureInput from 'vue-picture-input'

  export default  {
    name: 'inspectionArea',
    props: [],
    mounted() {
      this.getInspectionArea();

    },
    components: {
      PictureInput
    },
    data() {
      return {
        inspectionArea : {
          InspectionAreaItems : []
        },
        hideForm : false,
        showErrors : false,
        photos : {},
        photoStatuses : {}
      }
    },
    methods: {
      getInspectionArea : function(){
        this.inspectionArea = this.$store.getters.area( this.InspectionAreaID );
      },
      saveArea : function(){
          this.hideForm = true;
          this.showErrors = true;
          if( !this.checkFormReady() ){
            this.$store.dispatch( 'postMessage', { msg : 'You must choose a condition for each item.', timeout : 8000, allowClose : true });

            this.hideForm = false;
            return;
          }
          if( !this.checkFinishedUploading() ){
            this.$store.dispatch( 'postMessage', { msg : 'You have selected photos that still need to be uploaded. Please check the upload button by each photo.', timeout : 8000, allowClose : true });
            this.hideForm = false;
            return;
          }

        this.$store.dispatch( 'updateArea', this.inspectionArea ).then( () => {
          this.inspectionArea.InspectionAreaItems.push( { "Name":"COMPLETED" } ); //this isnt actually the one that gets saved, but we do this locally too in JS in case they navigate back. PHP does it better.
          router.push('/');

        }).then( () => {
          this.$store.dispatch( 'checkAllCompleted' );
        }).catch( reason => {
            this.$store.dispatch( 'postMessage', { msg : 'Could not save area. Please try again.', timeout : 8000, allowClose : true });
            console.log('ERROR: ', reason);
            this.hideForm = false;
        });
      },
      checkFormReady(){
        let valid = true;
        for( let area of this.inspectionArea.InspectionAreaItems ){
          if( area.Status == '' ){
            valid = false;
          }
        }
        return valid;
      },
      checkFinishedUploading(){
        let photosSelected = Object.keys( this.photoStatuses );
        for( let i = 0; i < photosSelected.length; i++ ){
          let status = this.photoStatuses[ photosSelected[i] ];
          if( status != 'Cannot upload on your device.' && status != 'Uploaded successfully.' && status != 'Error uploading. Try again.' ){
            return false;
          }
        }
        return true;
      },
      photoUploadStatus( inspectionAreaItemID ){
        return this.photoStatuses.hasOwnProperty(inspectionAreaItemID) ? this.photoStatuses[inspectionAreaItemID] : '';
      },
      onPhotoChanged(inspectionAreaItemID) {
        this.$set( this.photoStatuses, inspectionAreaItemID, 'Ready to upload.' );

        if (this.$refs[ 'pictureInput-' + inspectionAreaItemID ][0].file) {
          this.photos[ inspectionAreaItemID ] = this.$refs['pictureInput-' + inspectionAreaItemID ][0].file;
        } else {
          this.$set( this.photoStatuses, inspectionAreaItemID, 'Cannot upload on your device.' );
        }
      },
      onPhotoRemoved(inspectionAreaItemID) {
        delete this.photos[ inspectionAreaItemID ];
      },
      attemptPhotoUpload( inspectionAreaItemID) {
        if ( this.photos.hasOwnProperty( inspectionAreaItemID ) ){
          this.$set( this.photoStatuses, inspectionAreaItemID, 'Uploading...' );
          this.$store.dispatch( 'uploadPhoto', {
            'inspectionAreaItemID' : inspectionAreaItemID,
            'photo' : this.photos[ inspectionAreaItemID ]
          }).then( () => {
            this.$set( this.photoStatuses, inspectionAreaItemID, 'Uploaded successfully.' );
          }).catch( reason => {
            this.$set( this.photoStatuses, inspectionAreaItemID, 'Error uploading.');
          })
        }
      }
    },
    watch : {
      inspectionAreas : function(){
        this.getInspectionArea();
      }
    },
    computed: {
      alreadySubmitted : function(){
         for( let area of this.inspectionArea.InspectionAreaItems ){
          if( area.Name == 'COMPLETED' ){
            return true;
          }
        }
        return false;
      },
      inspectionAreas : function(){
        return this.$store.getters.areas;
      },
      InspectionAreaID : function(){
        return parseInt(this.$route.params.id);
      },
      title : function(){
        if ( this.inspectionArea && this.inspectionArea.hasOwnProperty('Name') ){
          return this.inspectionArea.Name;
        }else{
          return 'Loading room...';
        }
      },
    }
}
</script>

<style scoped lang="scss">
.show-errors .incomplete {
    border: 1px solid red;
    color: red;
}
</style>
